export enum LoanReportsOrigin {
  Origination = 0,
  Servicing = 1,
}
export interface ILoanReport {
  id: number
  type: string
  origin: LoanReportsOrigin
  title: string
  filters: Record<string, any>
  placeholders: string[]
  frequency: Record<string, any>
  sendTo: Array<any>
  createdBy: string
  createdAt: Date
}

export interface IReportHeaders {
  title: string
  data: string[]
}
